import getConfig from 'next/config'
import { useSelector } from 'react-redux'
import React, { useState, useEffect } from 'react'
import DeleteIcon from '@material-ui/icons/Delete'
import CreateIcon from '@material-ui/icons/Create'

import GridColumn from './column.json'
import { JettyApi } from '../../../api'
import ModalInput from './jetty-modal.container'
import { GenerateFilterTerm } from '../../../utils'
import { Card, MasterGrid, ModalDel, Alerts, MasterHeader, CodeCell } from '../../../components'

import { RowIcon, ActionDiv } from './jetty.styled'
import { WrapperContent } from '../../../styles/global.styled'

const Jetty = () => {
  const { publicRuntimeConfig } = getConfig()
  const appSize = useSelector((state) => state.appReducer)
  const usersLoginReducer = useSelector((state) => state.usersLoginReducer)

  const [state, setState] = useState({
    get: [],
  })
  const [editData, setEditData] = useState({
    Id: 0,
    Remarks: '',
    Draft: 0,
    Length: 0,
    Jetty_Name: '',
    Modified_By: '',
    Is_Active: true,
    Max_Vessel: 0,
    Location_Code: '',
    Location: '',
    Modified_Date: '',
    Jetty_Code: 'JTCXXXX',
  })

  const [pending, setPending] = useState(false)
  const [flag, setFlag] = useState(false)
  const [edited, setEdited] = useState(false)
  const [detail, setDetail] = useState(false)
  const [location, setLocation] = useState([])
  const [dataCount, setDataCount] = useState(0)
  const [firstLoad, setFirstLoad] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [flagStatus, setflagStatus] = useState(false)
  const [toggleDelete, setToggleDelete] = useState(false)
  const [flagModified, setFlagModified] = useState(false)
  const [deleteData, setDeleteData] = useState({ Id: 0 })
  const [showAlert, setAlert] = React.useState({
    visible: false,
    msg: '',
    success: false,
    type: '',
  })
  const [dataState, setDataState] = useState({ skip: 0, take: 20, filter: [], filterString: '[]' })

  const jettyRole = useSelector((state) =>
    state.usersLoginReducer.roleMapping.find((e) => e.activeName.includes('master-data/jetty'))
  )

  const handleClickOpen = () => {
    setEditData({
      Id: null,
      Draft: null,
      Remarks: '',
      Length: null,
      Jetty_Name: '',
      Is_Active: true,
      Max_Vessel: null,
      Location_Code: '',
      Location: '',
      Jetty_Code: 'JTCXXXX',
    })
    getLocation()
    setShowModal(true)
  }

  const handleClose = async () => {
    setDetail(false)
    await setFlag(false)
    await setEdited(false)
    await setShowModal(false)
    await setflagStatus(false)
    await setFlagModified(false)
  }

  const onPageChange = (event) => {
    setDataState({
      ...dataState,
      skip: event.page.skip,
      take: event.page.take,
    })

    fetchData({
      skip: event.page.skip,
      take: event.page.take,
      filterString: dataState.filterString,
    })
  }

  const onDataStateChange = ({ data }) => {
    setDataState({
      ...data,
      filter: data.filter,
      filterString: GenerateFilterTerm(data.filter, GridColumn),
    })
  }

  useEffect(() => {
    const jetty = setTimeout(() => {
      if(!firstLoad) {
        fetchData({ ...dataState,
          filterString: GenerateFilterTerm(dataState.filter, GridColumn) })
      }
    }, publicRuntimeConfig.FILTER_TIMEOUT)
    return () => clearTimeout(jetty)
  }, [dataState.filter])

  const heightGrid = appSize.height - 190 > 455 ? appSize.height - 190 : 455

  const submitDelete = async () => {
    try {
      const response = await JettyApi.DelDataJetty(deleteData.Id)
      if (response.data && response.data.result) {
        fetchData(dataState)
        setAlert({
          msg: 'Delete data has been successful',
          success: true,
          visible: true,
          type: 'delete',
        })
      } else {
        setAlert({
          msg: 'Cannot delete data',
          success: false,
          visible: true,
          type: 'delete',
        })
      }
    } catch (err) {
      console.log(err)
      setAlert({
        msg: 'Cannot delete data',
        success: false,
        visible: true,
        type: 'delete',
      })
      return err
    }
    setToggleDelete(!toggleDelete)
  }

  const actionCell = ({ dataItem, colSpan }) => (
    <td>
      <RowIcon colSpan={colSpan}>
        <ActionDiv
          hidden={!jettyRole.allowEdit}
          id='m-edit-btn'
          onClick={() => {
            setEdited(!edited)
            setflagStatus(true)
            setEditData(dataItem)
            getLocation()
            setShowModal(true)
          }}
        >
          <CreateIcon style={{ color: '#95C123' }} />
        </ActionDiv>
        <ActionDiv
          hidden={!jettyRole.allowDelete}
          id='m-delete-btn'
          onClick={() => {
            setDeleteData({ Id: dataItem.Id })
            setToggleDelete(!toggleDelete)
          }}
        >
          <DeleteIcon style={{ color: '#000000' }} />
        </ActionDiv>
      </RowIcon>
    </td>
  )

  const deleteModal = () => (
    <div>
      <ModalDel
        toggleDialog={() => {
          setToggleDelete(!toggleDelete)
        }}
        submitDelete={submitDelete}
        deleteText='Are you sure to delete the data ?'
      />
    </div>
  )

  const getLocation = async () => {
    try {
      const response = await JettyApi.GetListDataLocation()
      let portLocation = response.data.data
      if (usersLoginReducer && usersLoginReducer.UserLocations) {
        portLocation = portLocation.filter((e) =>
          usersLoginReducer.UserLocations.find((ele) => ele.LocationCode === e.Location_Code)
        )
      }
      setLocation(portLocation)
    } catch (err) {
      return err
    }
  }

  const fetchData = async ({ skip, take, filterString }) => {
    try {
      setPending(true)
      const dataClient = await JettyApi.GetListDataJetty(skip, take, filterString)
      setState({ get: dataClient.data.data })
      setDataCount(dataClient.data.dataCount)
      setPending(false)
    } catch (error) {
      setPending(false)
      console.log(error)
    }
  }

  useEffect(() => {
    if (JSON.stringify(state.get) === '[]') {
      fetchData(dataState)
      setFirstLoad(false)
    }
  }, [])

  const detailCell = (props) => {
    return (
      <CodeCell
        id='m-detail-btn'
        onClick={async () => {
          await setEditData(props.dataItem)
          await getLocation()
          await setFlag(true)
          await setDetail(!detail)
          await setflagStatus(true)
          await setFlagModified(true)
          await setShowModal(true)
        }}
      >
        {props.dataItem.Jetty_Code}
      </CodeCell>
    )
  }

  const mainGrid = () => (
    <MasterGrid
      data={state.get}
      height={heightGrid}
      total={dataCount}
      codeCell={detailCell}
      dataState={dataState}
      gridColumn={
        !jettyRole.allowEdit && !jettyRole.allowDelete
          ? GridColumn.filter((e) => e.title !== 'Action')
          : GridColumn
      }
      actionCell={actionCell}
      pageSizes={[20, 50, 100]}
      onPageChange={(e) => onPageChange(e)}
      onDataStateChange={(e) => onDataStateChange(e)}
      pending={pending}
    />
  )

  return (
    <WrapperContent>
      <Card>
        <MasterHeader
          allowCreate={jettyRole.allowCreate}
          title='MASTER DATA Jetty'
          buttonTitle='Add New'
          onClick={() => {
            handleClickOpen()
          }}
        />
        {toggleDelete && deleteModal()}
        {/* <GridContainer> */}
        {mainGrid()}
        {/* </GridContainer> */}
      </Card>
      <ModalInput
        flag={flag}
        edit={edited}
        detail={detail}
        editData={editData}
        location={location}
        fetchData={fetchData}
        showModal={showModal}
        dataState={dataState}
        flagStatus={flagStatus}
        setEditData={setEditData}
        handleClose={handleClose}
        flagModified={flagModified}
      />
      <Alerts
        type={showAlert.type}
        open={showAlert.visible}
        close={setAlert}
        msg={showAlert.msg}
        success={showAlert.success}
      />
    </WrapperContent>
  )
}
export default Jetty
